.root {
  display: flex;
}
